import { useSalesLocale } from '../../locale';

import React from 'react';
import { Empty, Typography } from 'antd';

const { Text } = Typography;

export const EmptyNotificationsState: React.FC = () => {
  const { t: salesText } = useSalesLocale();

  return (
    <div style={{ padding: 24 }}>
      <Empty description={salesText("No notifications right now.")}>
        <Text type="secondary">{salesText("You are all caught up.")}</Text>
      </Empty>
    </div>
  );
};
